import axios from "axios";

const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiOWE3dDYiLCJhIjoiY2xiZWF1MWdlMDluOTNvcGF6Zmx3bng2ayJ9.8bB7_aVExETntLYL9F0fOA';

export const getCoordinatesFromAddress = async (address) => {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(address)}.json?access_token=${MAPBOX_ACCESS_TOKEN}`;

    try {
        const response = await axios.get(url);
        if (response.data && response.data.features && response.data.features.length > 0) {
            const { center } = response.data.features[0];
            const [lng, lat] = center;
            return { lat, lng };
        } else {
            throw new Error('No results found for the specified address');
        }
    } catch (error) {
        console.error('Error fetching coordinates from address:', error);
        throw error;
    }
};
